import axios from 'axios';
import { applyAuthRequestInterceptor, applyEnvelopeInterceptor } from './axiosInterceptors';
import { API_BASE } from './runtimeConfig';

const apiClient = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

applyAuthRequestInterceptor(apiClient);
applyEnvelopeInterceptor(apiClient);

export default apiClient;
